import { createClient } from '@supabase/supabase-js';

// Supabase project configuration
export const SUPABASE_URL = 'https://syrngzrqituduptffanr.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN5cm5nenJxaXR1ZHVwdGZmYW5yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIzMTYxODgsImV4cCI6MjA3Nzg5MjE4OH0.j38wPVL-po6G5jYGq-c_Iui9Ey2T7LHZvJbNucWHOC8';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});